import { uniqueId } from 'lodash-es';
import {
  AddressType,
  ApiAddressOrdersResponse,
  ApiPatientAddressesRequest,
  ApiPatientAddressesResponse,
  ApiPatientAddressItemResponse,
} from 'src/app/core/models';

export const addresses: ApiPatientAddressItemResponse[] = [
  {
    addressId: 2001,
    line1: '12333 LONG STREET NAME',
    line2: 'SUITE 12',
    city: 'CHICAGO',
    state: 'IL',
    zip: '33221',
    addressTypes: [AddressType.Shipping, AddressType.Billing, AddressType.Correspondence],
  },
  {
    addressId: 2002,
    line1: '1305 GLENCREST LN',
    city: 'LONGVIEW',
    state: 'TX',
    zip: '75601-4324',
    addressTypes: [],
  },
  {
    addressId: 2003,
    line1: '1567 WORTHINGTON RD',
    city: 'MIAMI',
    state: 'FL',
    zip: '55509',
    addressTypes: [],
  },
];

export const getAddresses = (): ApiPatientAddressesResponse[] => [
  {
    addresses,
  },
];

export const updatePatientAddresses = (_: any, body: ApiPatientAddressesRequest): ApiPatientAddressesResponse[] => {
  return [
    {
      addresses: body.addresses.map((addr) => ({
        ...addr,
        addressId: addr.addressId || parseInt(uniqueId()), // set id for new addresses
      })),
    },
  ];
};

export const getAddressOrders = (): ApiAddressOrdersResponse => {
  return {
    patientId: 1000,
    addressId: 2001,
    reorders: [1011, 1012],
    shipments: [],
  };
};

export const updateAddressOrders = () => {};
